// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vMIR0","prefix":"styles_prefix__7l5Dk","postfix":"styles_postfix__BT7bE"};